export default "__VITE_ASSET__I5q7KEiB__"